module.exports = __webpack_public_path__ + "static/img/8.690371bd.png";